import React, { useContext, useEffect, useRef, useState } from "react";
import { AuthContext } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import { api } from "../api/client";
import { apiFetch } from "../utils/apiFetch";

const AIS_API = "https://api.ais-harvester.app";
const API = process.env.REACT_APP_API_URL || "";

const FLAG_MAP = {
  "Afghanistan": "🇦🇫", "Albania": "🇦🇱", "Algeria": "🇩🇿", "Antigua and Barbuda": "🇦🇬",
  "Argentina": "🇦🇷", "Australia": "🇦🇺", "Austria": "🇦🇹", "Bahamas": "🇧🇸",
  "Bahrain": "🇧🇭", "Bangladesh": "🇧🇩", "Barbados": "🇧🇧", "Belgium": "🇧🇪",
  "Belize": "🇧🇿", "Bermuda": "🇧🇲", "Brazil": "🇧🇷", "Bulgaria": "🇧🇬",
  "Cambodia": "🇰🇭", "Cameroon": "🇨🇲", "Canada": "🇨🇦", "Cayman Islands": "🇰🇾",
  "Chile": "🇨🇱", "China": "🇨🇳", "Colombia": "🇨🇴", "Comoros": "🇰🇲",
  "Croatia": "🇭🇷", "Cuba": "🇨🇺", "Cyprus": "🇨🇾", "Czech Republic": "🇨🇿",
  "Denmark": "🇩🇰", "Djibouti": "🇩🇯", "Ecuador": "🇪🇨", "Egypt": "🇪🇬",
  "Estonia": "🇪🇪", "Ethiopia": "🇪🇹", "Faroe Islands": "🇫🇴", "Fiji": "🇫🇯",
  "Finland": "🇫🇮", "France": "🇫🇷", "Gabon": "🇬🇦", "Georgia": "🇬🇪",
  "Germany": "🇩🇪", "Ghana": "🇬🇭", "Gibraltar": "🇬🇮", "Greece": "🇬🇷",
  "Honduras": "🇭🇳", "Hong Kong": "🇭🇰", "Hungary": "🇭🇺", "Iceland": "🇮🇸",
  "India": "🇮🇳", "Indonesia": "🇮🇩", "Iran": "🇮🇷", "Ireland": "🇮🇪",
  "Isle of Man": "🇮🇲", "Israel": "🇮🇱", "Italy": "🇮🇹", "Jamaica": "🇯🇲",
  "Japan": "🇯🇵", "Jordan": "🇯🇴", "Kazakhstan": "🇰🇿", "Kenya": "🇰🇪",
  "Kiribati": "🇰🇮", "South Korea": "🇰🇷", "Kuwait": "🇰🇼", "Latvia": "🇱🇻",
  "Lebanon": "🇱🇧", "Liberia": "🇱🇷", "Libya": "🇱🇾", "Lithuania": "🇱🇹",
  "Luxembourg": "🇱🇺", "Malaysia": "🇲🇾", "Maldives": "🇲🇻", "Malta": "🇲🇹",
  "Marshall Islands": "🇲🇭", "Mauritania": "🇲🇷", "Mauritius": "🇲🇺", "Mexico": "🇲🇽",
  "Moldova": "🇲🇩", "Monaco": "🇲🇨", "Mongolia": "🇲🇳", "Montenegro": "🇲🇪",
  "Morocco": "🇲🇦", "Mozambique": "🇲🇿", "Myanmar": "🇲🇲", "Namibia": "🇳🇦",
  "Netherlands": "🇳🇱", "New Zealand": "🇳🇿", "Nigeria": "🇳🇬", "Norway": "🇳🇴",
  "Oman": "🇴🇲", "Pakistan": "🇵🇰", "Panama": "🇵🇦", "Papua New Guinea": "🇵🇬",
  "Peru": "🇵🇪", "Philippines": "🇵🇭", "Poland": "🇵🇱", "Portugal": "🇵🇹",
  "Qatar": "🇶🇦", "Romania": "🇷🇴", "Russia": "🇷🇺", "Saint Kitts and Nevis": "🇰🇳",
  "Saint Vincent and the Grenadines": "🇻🇨", "Saudi Arabia": "🇸🇦", "Senegal": "🇸🇳",
  "Serbia": "🇷🇸", "Sierra Leone": "🇸🇱", "Singapore": "🇸🇬", "Slovakia": "🇸🇰",
  "Slovenia": "🇸🇮", "Somalia": "🇸🇴", "South Africa": "🇿🇦", "Spain": "🇪🇸",
  "Sri Lanka": "🇱🇰", "Sweden": "🇸🇪", "Switzerland": "🇨🇭", "Syria": "🇸🇾",
  "Taiwan": "🇹🇼", "Tanzania": "🇹🇿", "Thailand": "🇹🇭", "Togo": "🇹🇬",
  "Tonga": "🇹🇴", "Trinidad and Tobago": "🇹🇹", "Tunisia": "🇹🇳", "Turkey": "🇹🇷",
  "Turkmenistan": "🇹🇲", "Tuvalu": "🇹🇻", "Ukraine": "🇺🇦",
  "United Arab Emirates": "🇦🇪", "United Kingdom": "🇬🇧", "United States": "🇺🇸",
  "Uruguay": "🇺🇾", "Vanuatu": "🇻🇺", "Venezuela": "🇻🇪", "Vietnam": "🇻🇳",
  "Yemen": "🇾🇪",
};

function countryFlag(name) {
  if (!name) return "";
  return FLAG_MAP[name] || "";
}

export default function MyFleet() {
  const { token } = useContext(AuthContext);
  const navigate = useNavigate();

  const [vessels, setVessels] = useState([]);
  const [err, setErr] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [aisResults, setAisResults] = useState([]);
  const [oskarResults, setOskarResults] = useState([]);
  const [searchOpen, setSearchOpen] = useState(false);
  const [searching, setSearching] = useState(false);
  const [addingId, setAddingId] = useState(null);
  const [addedId, setAddedId] = useState(null);
  const timerRef = useRef(null);
  const [expandedId, setExpandedId] = useState(null);
  const [vesselLinks, setVesselLinks] = useState({});
  const [linksLoading, setLinksLoading] = useState({});
  const [reportLoading, setReportLoading] = useState(null);

  async function loadFleet() {
    try {
      const data = await api("/vessels", { token });
      setVessels(Array.isArray(data) ? data : []);
    } catch {
      setErr("Failed to load vessels.");
    }
  }

  async function viewLastReport(vesselId, inspectionId) {
    if (!token || !inspectionId) return;
    setReportLoading(vesselId);
    try {
      const baseUrl = (API || "").replace(/\/+$/, "");
      const res = await apiFetch(`${baseUrl}/india/inspections/${inspectionId}/report/final/cached`, {
        method: "GET",
        headers: { Authorization: `Bearer ${token}`, Accept: "application/pdf" },
      });
      if (!res.ok) throw new Error(`PDF request failed (${res.status})`);
      const blob = await res.blob();
      const pdfUrl = URL.createObjectURL(blob);
      window.open(pdfUrl, "_blank", "noopener,noreferrer");
      setTimeout(() => URL.revokeObjectURL(pdfUrl), 60_000);
    } catch {
      setErr("Could not open the last report. Please try again.");
    } finally {
      setReportLoading(null);
    }
  }

  async function loadVesselLinks(vesselId) {
    if (vesselLinks[vesselId] !== undefined) return;
    setLinksLoading(prev => ({ ...prev, [vesselId]: true }));
    try {
      const data = await api(`/vessels/${vesselId}/links`, { token });
      setVesselLinks(prev => ({ ...prev, [vesselId]: data }));
    } catch {
      setVesselLinks(prev => ({ ...prev, [vesselId]: { company: null, inspections: [] } }));
    } finally {
      setLinksLoading(prev => ({ ...prev, [vesselId]: false }));
    }
  }

  useEffect(() => {
    if (!token) return;
    loadFleet();
  }, [token]); // eslint-disable-line react-hooks/exhaustive-deps

  function handleSearchChange(e) {
    const val = e.target.value;
    setSearchQuery(val);
    clearTimeout(timerRef.current);
    if (val.length < 3) {
      setAisResults([]);
      setOskarResults([]);
      setSearchOpen(false);
      return;
    }
    timerRef.current = setTimeout(async () => {
      setSearching(true);
      try {
        const [aisRes, oskarRes] = await Promise.allSettled([
          apiFetch(`${AIS_API}/vessels/search?q=${encodeURIComponent(val)}&limit=10`).then(r => r.json()),
          apiFetch(`${API}/vessels?q=${encodeURIComponent(val)}`, {
            headers: { Authorization: `Bearer ${token}` },
          }).then(r => r.json()),
        ]);
        setAisResults(aisRes.status === "fulfilled" && Array.isArray(aisRes.value) ? aisRes.value : []);
        const oskarData = oskarRes.status === "fulfilled" ? oskarRes.value : [];
        setOskarResults(Array.isArray(oskarData) ? oskarData : []);
        setSearchOpen(true);
      } catch {
        // silent
      } finally {
        setSearching(false);
      }
    }, 350);
  }

  async function handleSelect(source, vessel) {
    setAddingId(source === "oskar" ? String(vessel.id) : String(vessel.mmsi));
    try {
      if (source === "oskar") {
        await api(`/vessels/${vessel.id}/add-to-fleet`, { method: "POST", token });
        await loadFleet();
        setAddedId(String(vessel.id));
        setTimeout(() => setAddedId(null), 2000);
      } else {
        const existing = vessels.find(v => String(v.mmsi) === String(vessel.mmsi));
        if (existing) {
          await api(`/vessels/${existing.id}/add-to-fleet`, { method: "POST", token });
          await loadFleet();
          setAddedId(String(existing.id));
          setTimeout(() => setAddedId(null), 2000);
        } else {
          const result = await api("/vessels", {
            method: "POST",
            token,
            body: {
              name: vessel.name,
              mmsi: vessel.mmsi ? String(vessel.mmsi) : null,
              imo: vessel.imo ? String(vessel.imo) : null,
              callsign: vessel.callsign || null,
              length: vessel.length || null,
              width: vessel.width || null,
              draft: vessel.draught || null,
            },
          });
          const newId = result?.id ?? result?.vessel?.id;
          if (newId) {
            await api(`/vessels/${newId}/add-to-fleet`, { method: "POST", token });
            await loadFleet();
            setAddedId(String(newId));
            setTimeout(() => setAddedId(null), 2000);
            if (vessel.imo) triggerEnrichment(String(vessel.imo), newId);
          }
        }
      }
    } catch (e) {
      // If vessel already exists in Oskar (MMSI conflict), find it and add to fleet
      if (e?.status === 409 || String(e?.message).includes("already exists") || String(e?.message).includes("409")) {
        try {
          const res = await apiFetch(`${API}/vessels?q=${encodeURIComponent(vessel.mmsi || vessel.name)}`, {
            headers: { Authorization: `Bearer ${token}` },
          });
          const data = await res.json();
          const found = Array.isArray(data)
            ? data.find(x => vessel.mmsi && String(x.mmsi) === String(vessel.mmsi))
            : null;
          if (found) {
            await api(`/vessels/${found.id}/add-to-fleet`, { method: "POST", token });
            await loadFleet();
            setAddedId(String(found.id));
            setTimeout(() => setAddedId(null), 2000);
          }
        } catch {
          // silent fallback
        }
      }
    } finally {
      setAddingId(null);
      setSearchQuery("");
      setAisResults([]);
      setOskarResults([]);
      setSearchOpen(false);
    }
  }

  async function triggerEnrichment(imo, vesselId = null) {
    try {
      const res = await apiFetch(`${AIS_API}/vessels/${imo}/enrich`, { method: "POST" });
      if (res.ok) {
        const json = await res.json();
        const data = json.data || null;
        if (data) {
          const resolvedId = vesselId ?? vessels.find(v => String(v.imo) === String(imo))?.id ?? null;
          if (resolvedId) {
            try {
              await api(`/vessels/${resolvedId}`, {
                token,
                method: "PATCH",
                body: {
                  equasis_manager: data.equasis_manager && data.equasis_manager !== "UNKNOWN"
                    ? data.equasis_manager : null,
                  equasis_manager_imo: data.equasis_manager_imo || null,
                  equasis_manager_address: data.equasis_manager_address || null,
                  equasis_owner: data.equasis_owner && data.equasis_owner !== "UNKNOWN"
                    ? data.equasis_owner : null,
                  equasis_flag: data.equasis_flag || null,
                  equasis_year_built: data.equasis_year_built || null,
                  equasis_gt: data.equasis_gt || null,
                  equasis_dwt: data.equasis_dwt || null,
                },
              });
              if (data.equasis_manager && data.equasis_manager !== "UNKNOWN") {
                try {
                  await api(`/vessels/${resolvedId}/link-company`, {
                    token,
                    method: "POST",
                    body: {
                      equasis_manager: data.equasis_manager,
                      equasis_manager_imo: data.equasis_manager_imo || null,
                      equasis_manager_address: data.equasis_manager_address || null,
                      equasis_owner: data.equasis_owner && data.equasis_owner !== "UNKNOWN"
                        ? data.equasis_owner : null,
                    },
                  });
                } catch {
                  // silent — non-fatal
                }
              }
            } catch {
              // silent — non-fatal
            }
          }
        }
      }
    } catch {
      // silent — enrichment is best-effort
    }
  }

  const hasAis = aisResults.length > 0;
  const hasOskar = oskarResults.length > 0;

  return (
    <div style={{ maxWidth: 900, margin: "0 auto", padding: "32px 24px" }}>
      <div style={{ marginBottom: 24 }}>
        <h1 style={{ fontSize: 22, fontWeight: 700, color: "#1e3a5f", margin: 0 }}>Vessels</h1>
      </div>

      {err && (
        <div style={{ marginBottom: 16, fontSize: 14, color: "#c0392b", background: "#fdecea", border: "1px solid #f5c6c2", borderRadius: 8, padding: "10px 14px" }}>
          {err}
        </div>
      )}

      {/* Search / add to fleet */}
      <div style={{ background: "white", border: "1px solid #d0dcea", borderRadius: 12, padding: 20, marginBottom: 24 }}>
        <div style={{ fontSize: 13, fontWeight: 600, color: "#1e3a5f", marginBottom: 8 }}>Add vessel to your fleet</div>
        <div style={{ fontSize: 12, color: "#6b8cae", marginBottom: 12 }}>Search by vessel name, MMSI or IMO number</div>
        <div style={{ position: "relative" }}>
          <input
            type="text"
            value={searchQuery}
            onChange={handleSearchChange}
            placeholder="Search vessels…"
            style={{
              width: "100%", boxSizing: "border-box",
              border: "1px solid #d0dcea", borderRadius: 6,
              padding: "8px 10px", fontSize: 14,
            }}
          />
          {searching && (
            <span style={{ position: "absolute", right: 10, top: 10, fontSize: 12, color: "#6b8cae" }}>…</span>
          )}
        </div>

        {searchOpen && (hasAis || hasOskar) && (
          <div style={{ marginTop: 4, border: "1px solid #d0dcea", borderRadius: 8, background: "white", maxHeight: 260, overflowY: "auto" }}>
            {hasOskar && (
              <>
                <div style={{ padding: "6px 12px", fontSize: 11, fontWeight: 600, color: "#6b8cae", borderBottom: "1px solid #e8eef5", background: "#f8fafc" }}>
                  In your Oskar database
                </div>
                {oskarResults.map((v, idx) => (
                  <button
                    key={`oskar-${v.id}`}
                    disabled={!!addingId}
                    onClick={() => handleSelect("oskar", v)}
                    style={{
                      display: "flex", justifyContent: "space-between", alignItems: "center",
                      width: "100%", textAlign: "left", padding: "8px 12px",
                      background: "none", border: "none", cursor: addingId ? "default" : "pointer",
                      borderBottom: idx < oskarResults.length - 1 || hasAis ? "1px solid #e8eef5" : "none",
                      opacity: addingId ? 0.6 : 1,
                    }}
                  >
                    <span style={{ fontSize: 14, color: "#1e3a5f" }}>
                      {v.name}{v.type_name ? ` · ${v.type_name}` : ""}
                    </span>
                    <span style={{ fontSize: 12, color: "#6b8cae" }}>{v.mmsi || ""}</span>
                  </button>
                ))}
              </>
            )}
            {hasAis && (
              <>
                <div style={{ padding: "6px 12px", fontSize: 11, fontWeight: 600, color: "#6b8cae", borderBottom: "1px solid #e8eef5", background: "#f8fafc" }}>
                  From AIS database
                </div>
                {aisResults.map((v, idx) => (
                  <button
                    key={`ais-${v.mmsi}`}
                    disabled={!!addingId}
                    onClick={() => handleSelect("ais", v)}
                    style={{
                      display: "flex", justifyContent: "space-between", alignItems: "center",
                      width: "100%", textAlign: "left", padding: "8px 12px",
                      background: "none", border: "none", cursor: addingId ? "default" : "pointer",
                      borderBottom: idx < aisResults.length - 1 ? "1px solid #e8eef5" : "none",
                      opacity: addingId ? 0.6 : 1,
                    }}
                  >
                    <span style={{ fontSize: 14, color: "#1e3a5f" }}>
                      {v.name}{v.type_name ? ` · ${v.type_name}` : ""}
                    </span>
                    <span style={{ fontSize: 12, color: "#6b8cae" }}>{v.mmsi || ""}</span>
                  </button>
                ))}
              </>
            )}
          </div>
        )}

        {addedId && (
          <div style={{ marginTop: 10, padding: "8px 12px", background: "#e6f4ea", border: "1px solid #c3e6cb", borderRadius: 6, fontSize: 13, color: "#2e7d32" }}>
            ✓ Added to your fleet
          </div>
        )}
      </div>

      {/* Fleet list */}
      <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
        {vessels.length === 0 ? (
          <div style={{ textAlign: "center", fontSize: 14, color: "#6b8cae", padding: "40px 0" }}>
            No vessels in your fleet yet. Search above to add vessels.
          </div>
        ) : (
          vessels.map(v => {
            const isExpanded = expandedId === v.id;
            const links = vesselLinks[v.id];
            const loadingLinks = linksLoading[v.id];

            function toggleExpand() {
              if (isExpanded) {
                setExpandedId(null);
              } else {
                setExpandedId(v.id);
                loadVesselLinks(v.id);
              }
            }

            const flag = v.equasis_flag ? countryFlag(v.equasis_flag) : "";
            const collapsedMeta = [
              flag ? `${flag} ${v.equasis_flag}` : null,
              v.mmsi ? `MMSI ${v.mmsi}` : null,
              v.type_name || null,
            ].filter(Boolean).join(" · ");

            const statusColors = {
              completed: { bg: "#e6f4ea", color: "#2e7d32" },
              in_progress: { bg: "#fef9ec", color: "#92610a" },
              draft: { bg: "#f4f7fb", color: "#6b8cae" },
            };
            function statusBadge(status) {
              const s = statusColors[status] || { bg: "#f4f7fb", color: "#6b8cae" };
              return (
                <span style={{
                  display: "inline-block", padding: "2px 8px", borderRadius: 20,
                  fontSize: 11, fontWeight: 500, background: s.bg, color: s.color,
                }}>
                  {status === "in_progress" ? "In progress" : status ? status.charAt(0).toUpperCase() + status.slice(1) : "—"}
                </span>
              );
            }

            return (
              <div key={v.id} style={{ background: "white", border: "1px solid #d0dcea", borderRadius: 12, overflow: "hidden" }}>
                {/* Collapsed header — always visible */}
                <button
                  onClick={toggleExpand}
                  style={{
                    width: "100%", textAlign: "left", background: "none", border: "none",
                    cursor: "pointer", padding: "14px 16px",
                    display: "flex", alignItems: "center", justifyContent: "space-between",
                  }}
                >
                  <div style={{ display: "flex", flexDirection: "column", gap: 2 }}>
                    <span style={{ fontSize: 15, fontWeight: 600, color: "#1e3a5f" }}>
                      {v.name || `Vessel #${v.id}`}
                    </span>
                    {collapsedMeta && (
                      <span style={{ fontSize: 12, color: "#94afc9" }}>{collapsedMeta}</span>
                    )}
                  </div>
                  <span style={{ fontSize: 16, color: "#6b8cae", marginLeft: 12 }}>
                    {isExpanded ? "▲" : "▼"}
                  </span>
                </button>

                {/* Expanded section */}
                {isExpanded && (
                  <div style={{ borderTop: "1px solid #e8eef5", padding: "16px 16px 20px" }}>
                    <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 12 }}>
                      <button
                        onClick={() => navigate(`/vessels/${v.id}/edit`)}
                        style={{ padding: "4px 12px", fontSize: 12, border: "1px solid #d0dcea", borderRadius: 6, background: "white", cursor: "pointer", color: "#1e3a5f" }}
                      >
                        Enrich data
                      </button>
                    </div>

                    {/* Vessel details */}
                    <div style={{ display: "flex", flexDirection: "column", gap: 6, marginBottom: 16 }}>
                      {v.type_name && (
                        <div style={{ fontSize: 13, color: "#6b8cae" }}>{v.type_name}</div>
                      )}
                      <div style={{ fontSize: 12, color: "#94afc9" }}>
                        {[
                          v.equasis_flag ? `${flag} ${v.equasis_flag}` : null,
                          v.mmsi ? `MMSI ${v.mmsi}` : null,
                          v.imo ? `IMO ${v.imo}` : null,
                          v.callsign ? `Callsign ${v.callsign}` : null,
                        ].filter(Boolean).join(" · ")}
                      </div>
                      {(v.length || v.width || v.draft) && (
                        <div style={{ fontSize: 12, color: "#94afc9" }}>
                          {[
                            v.length ? `L: ${v.length}m` : null,
                            v.width ? `W: ${v.width}m` : null,
                            v.draft ? `D: ${v.draft}m` : null,
                          ].filter(Boolean).join(" · ")}
                        </div>
                      )}
                      {(v.equasis_owner || v.equasis_manager) && (
                        <div style={{ fontSize: 12, color: "#6b8cae", fontStyle: "italic" }}>
                          {v.equasis_manager && v.equasis_manager !== "UNKNOWN" ? v.equasis_manager : v.equasis_owner}
                        </div>
                      )}
                      {(v.equasis_year_built || v.equasis_gt) && (
                        <div style={{ fontSize: 12, color: "#94afc9" }}>
                          {[
                            v.equasis_year_built ? `Built ${v.equasis_year_built}` : null,
                            v.equasis_gt ? `GT ${v.equasis_gt?.toLocaleString()}` : null,
                            v.equasis_dwt ? `DWT ${v.equasis_dwt?.toLocaleString()}` : null,
                          ].filter(Boolean).join(" · ")}
                        </div>
                      )}
                      {v.last_inspected_at && (
                        <div style={{ fontSize: 12, color: "#6b8cae" }}>
                          Last inspected:{" "}
                          {new Date(v.last_inspected_at).toLocaleDateString("nl-NL", { day: "2-digit", month: "short", year: "numeric" })}
                          {v.last_inspection_name ? ` — ${v.last_inspection_name}` : ""}
                        </div>
                      )}
                      {v.my_last_report_s3_key && v.my_last_inspection_id && (
                        <div style={{ marginTop: 2 }}>
                          <button
                            onClick={() => viewLastReport(v.id, v.my_last_inspection_id)}
                            disabled={reportLoading === v.id}
                            style={{
                              fontSize: 12, color: "#1e7fc7", background: "none", border: "none",
                              padding: 0, cursor: reportLoading === v.id ? "default" : "pointer",
                              textDecoration: "underline",
                            }}
                          >
                            {reportLoading === v.id ? "Opening…" : "View last report"}
                          </button>
                        </div>
                      )}
                    </div>

                    {/* Links section — loaded on expand */}
                    {loadingLinks && (
                      <div style={{ fontSize: 13, color: "#94afc9", paddingTop: 4 }}>Loading…</div>
                    )}

                    {links && (
                      <>
                        {/* Company */}
                        {links.company && (
                          <div style={{ marginBottom: 12 }}>
                            <div style={{ fontSize: 11, fontWeight: 600, color: "#94afc9", textTransform: "uppercase", letterSpacing: "0.06em", marginBottom: 6 }}>Company</div>
                            <div style={{ fontSize: 13, color: "#1e3a5f", fontWeight: 500 }}>
                              {links.company.name}
                              {links.company.country && (
                                <span style={{ marginLeft: 6, fontSize: 12, color: "#94afc9", fontWeight: 400 }}>({links.company.country})</span>
                              )}
                            </div>
                          </div>
                        )}

                        {/* Inspections */}
                        {links.inspections.length > 0 && (
                          <div>
                            <div style={{ fontSize: 11, fontWeight: 600, color: "#94afc9", textTransform: "uppercase", letterSpacing: "0.06em", marginBottom: 6 }}>Inspections</div>
                            <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
                              {links.inspections.map(ins => (
                                <div key={ins.id} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", fontSize: 13, padding: "6px 0", borderBottom: "1px solid #f0f4f8" }}>
                                  <div style={{ display: "flex", flexDirection: "column", gap: 2 }}>
                                    {ins.accessible ? (
                                      <button
                                        onClick={() => navigate(`/inspections/${ins.id}`)}
                                        style={{ background: "none", border: "none", cursor: "pointer", padding: 0, textAlign: "left", fontSize: 13, color: "#1e3a5f", fontWeight: 500 }}
                                      >
                                        {ins.name}
                                      </button>
                                    ) : (
                                      <span style={{ fontSize: 13, color: "#94afc9" }}>{ins.name}</span>
                                    )}
                                    {ins.date && (
                                      <span style={{ fontSize: 11, color: "#94afc9" }}>
                                        {new Date(ins.date).toLocaleDateString("nl-NL", { day: "2-digit", month: "short", year: "numeric" })}
                                      </span>
                                    )}
                                  </div>
                                  {statusBadge(ins.status)}
                                </div>
                              ))}
                            </div>
                          </div>
                        )}
                      </>
                    )}
                  </div>
                )}
              </div>
            );
          })
        )}
      </div>
    </div>
  );
}
